// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_8aI","cls2":"WorkCard-cls2_Scd WorkCard-cls1_8aI"};